import React , { useEffect , useState } from "react";
import "./imageContainer.css";

//
import { ChangedData } from "../../assets/ChangedData/ChangedData";


export var socialDaata = "";

export const ImageContainer = () =>{

    /*_*/   const [allData , setAllData] = useState("");
    /*_*/   const [ image , setImage ] = useState("");
    /*_*/   const [ name , setName ] = useState("");
    /*_*/   const [ berf , setBerf ] = useState("");
    /*_*/   const [ rendSocial , setRendSocial ] = useState(<div></div>);

    useEffect(()=> {   
        fetchData();

    },[]);
    
    useEffect(()=>{
        forAdTool();
    },[]);

    const fetchData = async () =>{
        await fetch(`${process.env.PUBLIC_URL}/mydata/cvigCard.json`).then((r) => r.json()).then((data) =>{
            setImage(data.Image);
            setName(data.Name);
            setBerf(data.berf);
            rendSocials(data.socialmedia);
            setAllData(data);
            socialDaata = data;
        })
    }

    const rendSocials = (socials) =>{
        const rend = socials.map( (card , i)  => 
            <div className="LinkCirSocialMedia d-flex justify-content-center align-items-center" id={ `Connsmi_${i}` }>
                <a href={card.link} target="_blank" className="d-flex justify-content-center align-items-center" id={ `smi_${i}` }> <img src={card.logo} className="sociconCv" id={ `smi_${i}` } /> </a>
            </div>    
        );
        setRendSocial(rend);
    }


    const forAdTool = () =>{
        if (localStorage.getItem("isLogged") == "true") {
            const sawwllksssaqseerwww = document.getElementById("sawwllksssaqseerwww");
            sawwllksssaqseerwww.addEventListener("click" , ()=>{
                setTimeout(() => {
                    const AtoolSocIconDe = document.getElementsByClassName("AtoolSocIconDe");
                    for (let i = 0; i < AtoolSocIconDe.length; i++) {
                        AtoolSocIconDe[i].addEventListener("click" , () => {
                            setTimeout(() => {
                                rendSocials(socialDaata.socialmedia);
                            }, 200);
                        });
                    }
                }, 100);
            });

            const addbtnATOOLsoc = document.getElementById("addbtnATOOLsoc");
            addbtnATOOLsoc.addEventListener("click", () =>{
                setTimeout(() => {
                    rendSocials(socialDaata.socialmedia);
                }, 200);
            });
        }
    }












    //_________________||" Admin Functions "||________________\\
 
    const hoverEditOn = (event) => {
        if (localStorage.getItem("isLogged") == "true") {
            event.target.classList.add("editCursurOnHover");
        }
    }
    const hoverEditOut = (event) => {
        let TargetElement = event.target;
        let inn = TargetElement.classList[0];
        let toRemoveElement = document.querySelector("."+inn+" .EditLogoContainer");
        if (toRemoveElement){
            TargetElement.removeChild(toRemoveElement);
        }
    }

    const openDropFContainer =()=>{
        if (localStorage.getItem("isLogged") == "true") {
            const DropFileContainer = document.getElementById("DropFileContainer");
            DropFileContainer.classList.remove("DropFileContainerZu");

            const DropFileBG = document.getElementById("DropFileBG");
            const BodyVisableZu = document.getElementById("BodyVisableZu");

            setTimeout(() => {
                DropFileBG.classList.remove("DropFileBGZu");
            }, 10);

            setTimeout(() => {
                BodyVisableZu.classList.remove("BodyVisableZu");
            }, 300);
        }
    }


    const toTextEditFunction = (event) => {
        if (localStorage.getItem("isLogged") == "true") {
            let toTextEdit = event.target;
            let Oldtext = toTextEdit.innerText;
            let Classes = toTextEdit.classList;
            let width = toTextEdit.getBoundingClientRect().width;
            let height = toTextEdit.getBoundingClientRect().height;
            let id = toTextEdit.linke;
    
            toTextEdit.innerHTML = "";
            let textArea = document.createElement("textarea");
            toTextEdit.appendChild(textArea);
            textArea.classList.add("TextEditArea");
    
            for (let i = 0; i < Classes.length; i++) {
                textArea.classList.add(Classes[i]);
            }
    
            textArea.focus();
            textArea.value = Oldtext;
    
            textArea.style.width = width + 20 + "px";
            textArea.style.height = height + 10 + "px";
    

            toTextEdit.addEventListener("focusout" , ()=> {
                
                if ( textArea.value.length > 0) {
                    let NewValueTextarea = textArea.value
                    toTextEdit.innerHTML = NewValueTextarea;
                    // file name
                    let APIfileName = event.target.getAttribute("data-f");
                    // atribut name
                    let atributname = event.target.id;
                    // get text after chanched
                    let textafter = event.target.innerHTML;

                    if (Oldtext != textafter) {
                        let SaveChangContainer = document.getElementById("SaveChangContainer");
                        SaveChangContainer.style.visibility = "visible";

                        allData[atributname] = textafter;

                        if ( !ChangedData[APIfileName]) {
                            ChangedData[APIfileName] = allData;
                            console.log(ChangedData);
                        }
                    }
                    
                }else{
                    // return old Text
                    toTextEdit.innerHTML = Oldtext;
                }
            });
            
            toTextEdit.addEventListener("keydown" , ()=> {
                textArea.style.width = "max-content";
                textArea.style.height = "max-content";
            });
        }
    }



























    return(
        <div className="imageMainContainer">

            <div className="cvimageContainer">
                <img src={image}  className="cvImage" id="cvImage" onClick={openDropFContainer} onMouseOver={hoverEditOn} onMouseLeave={hoverEditOut} />
            </div>

            <div className="zabtabme">

                <div className="imageCvLableName">
                    <span className="cvMainName" id="Name" onMouseOver={hoverEditOn} onMouseLeave={hoverEditOut} data-f="cvigCard" onClick={toTextEditFunction} >  {name}</span>
                    <p className="udtLable" id="berf" onMouseOver={hoverEditOn} onMouseLeave={hoverEditOut} data-f="cvigCard" onClick={toTextEditFunction}> { berf } </p>
                </div>
                
                <div className="socialMediaLinks d-flex align-items-center justify-content-center" id="LinkCirSocialMedia">
                    {  rendSocial }
                </div>

            </div>
            
        </div>
    );
}